import {useEffect, useState} from 'react';
import { Select } from 'antd';
import {useApi} from "../provider/ApiProvider";
const { Option } = Select;

export default function CompanySelector({value, onChange, customerId}){


    const {api} = useApi();
    const [options, setOptions] = useState([]);

    useEffect(() =>{
       load(customerId);
    },[customerId])

    async function load(customerId){
        if(customerId){
            await  api.get('/companyRouter/company/all', {CustomerId: customerId,skip:0, max:1000}).then(resp => {
                setOptions(resp.data);
                console.log('respp');
            })
        }else{
            await  api.get('/companyRouter/company/all',{skip:0, max:1000}).then(resp => {
                setOptions(resp.data);
                console.log('respp2');

            })
        }

    }

    function onChangeSelect(value) {
        let found = options.find(x => x.id === value);
       onChange(value, found);
    }

    return (<div>
        <Select
            showSearch
            placeholder="Firma/Şube Seç"
            optionFilterProp="children"
            onChange={onChangeSelect}
            value={value}
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
        >
            {options.length > 0 && options.map((item, idx) => (
                <Option value={item.id}>{item.name}</Option>
            ))}
        </Select>
    </div>)
}
